// extracted by mini-css-extract-plugin
export default {"tx":"_156b4e0955","line":"f7a9008f86"};